import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../../../components/MainBody/MainBody";
import MainTabList from "../../../../components/MainBody/MainTabList";
import RiskAssementList from "./RiskAssementList";

const tabsKey = [
  {
    name: "ML",
    tabName: "aml",
    value: 1,
  },
  {
    name: "TF/PF",
    tabName: "ctf",
    value: 2,
  },
];

const RiskAssessment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("subChildTab") || "aml";

  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);

  useEffect(() => {
    navigate(
      `?tab=program&childTab=risk-assessment&subChildTab=${
        tabsKey?.find((item) => item?.value === activeTab)?.tabName
      }`,
      {
        replace: true,
      }
    );
  }, [activeTab, navigate]);

  return (
    <>
      <MainBody
        search={false}
        loading={false}
        innerBody={true}
        actionAlign={"end"}
        actionContent={""}
      >
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={"p-0 border-none bg-transparent"}
        >
          {activeTab === 1 ? (
            <RiskAssementList sectionType={"AML"} />
          ) : activeTab === 2 ? (
            <RiskAssementList sectionType={"CTF"} />
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default RiskAssessment;
